import * as React from "react";
import { OverlayTrigger, Tooltip, Image } from "react-bootstrap";
import { shallowEqual } from "react-redux";
import { useAppSelector } from "../redux/store";

const { useState } = React;
interface CopyButtonProps {
  textToCopy: string;
  tooltipText: string;
  id: string;
  color?: 'white';
}

export const CopyButton: React.FC<CopyButtonProps> = ({ textToCopy, tooltipText, id, color }) => {
  const translationText = useAppSelector(state => state.translations, shallowEqual);
  const [copied, setCopied] = useState(false);
  const url = color === 'white' ? "/copyIconWhite.svg" : "/copyIconBlue.svg";
  const overlayTooltip = <Tooltip id={`copy-${id}-tooltip`}>{copied ? translationText.copied || 'Copied!' : tooltipText}</Tooltip>;
  const copyItem = () => {
    try {
      navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch (error) {
      // Clipboard API can fail in insecure contexts or if permission denied
    }
  };

  return (
    <div className="ml-2">
      <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={overlayTooltip} >
        <Image src={url} className='copy-series-id' data-testid='copy-button' onClick={copyItem} />
      </OverlayTrigger>
    </div>
  );
}